import { render, staticRenderFns } from "./ContentNodeEditor.vue?vue&type=template&id=5a399d60&"
import script from "./ContentNodeEditor.vue?vue&type=script&lang=js&"
export * from "./ContentNodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./ContentNodeEditor.vue?vue&type=style&index=0&id=5a399d60&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports